import { render } from "./ChallengeUserItemSelected.vue?vue&type=template&id=62573740&scoped=true"
import script from "./ChallengeUserItemSelected.vue?vue&type=script&lang=js"
export * from "./ChallengeUserItemSelected.vue?vue&type=script&lang=js"

import "@/css/components/challenge-user-item-selected.css?vue&type=style&index=0&id=62573740&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62573740"]])

export default __exports__